/* snoot: Symptom Checker. Counts the tapped signs, fills the meter, swaps the message, scrolls to the answer. */
(function () {
  function init(root) {
    if (root.__ssc) return;
    root.__ssc = true;
    var opts = [].slice.call(root.querySelectorAll('.ssc__opt'));
    var res = root.querySelector('.ssc__result'), msg = root.querySelector('[data-ssc-msg]');
    var tpl = {};
    [].forEach.call(root.querySelectorAll('[data-ssc-m]'), function (t) { tpl[t.getAttribute('data-ssc-m')] = t.innerHTML; });
    opts.forEach(function (o) {
      o.addEventListener('click', function () {
        o.setAttribute('aria-pressed', o.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        var n = root.querySelectorAll('.ssc__opt[aria-pressed=true]').length;
        res.setAttribute('data-n', n);
        if (tpl[n] !== undefined) msg.innerHTML = tpl[n];
        msg.hidden = !msg.innerHTML.trim();
        res.style.setProperty('--ssc-n', n);
      });
    });
    var go = root.querySelector('.ssc__go'), id = root.getAttribute('data-target');
    if (go) go.addEventListener('click', function (e) {
      var t = id && (document.getElementById(id) || document.querySelector('[id$="__' + id + '"]'));
      if (!t) return;
      e.preventDefault();
      t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
  function boot() { [].forEach.call(document.querySelectorAll('[data-ssc]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
